export const API_URL = process.env.VUE_APP_NODE_ENV === 'development'
    ? process.env.VUE_APP_API_DEVELOPMENT_URL
    : process.env.VUE_APP_API_PRODUCTION_URL

export default {
    API_BASE: API_URL,
    APP_TITLE: 'SoloFoodies Admin',
    DEBUG: process.env.VUE_APP_DEBUG === 'true'
}